import React from 'react';
import { motion } from 'framer-motion';
export function EmpathySection() {
  return <section className="py-8 md:py-12 px-4 md:px-6" style={{
    backgroundColor: 'var(--bg-surface)'
  }} data-id="element-147">
      <div className="max-w-[680px] mx-auto" data-id="element-148">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-3 md:space-y-5" data-id="element-149">
          <h2 className="text-xl md:text-3xl font-serif text-[var(--text-heading)] text-center" data-id="element-150">
            Déjame adivinar dónde estás ahora mismo.
          </h2>

          <div className="space-y-3 md:space-y-4 text-base md:text-lg text-[var(--text-primary)] leading-relaxed font-light" data-id="element-151">
            <p data-id="element-152">
              Si hoy recibiste una notificación de deportación... si cada sirena
              en la calle te acelera el corazón... si has gastado miles con
              "notarios" que no te dan papeles reales...{' '}
              <strong className="text-[var(--text-heading)]" data-id="element-153">
                este es tu Plan B.
              </strong>
            </p>
            <div className="bg-[var(--bg-card)] p-4 md:p-6 rounded-lg border border-[var(--accent)]/15" data-id="element-154">
              <p className="text-lg md:text-xl font-serif text-[var(--accent)] text-center italic" data-id="element-155">
                No necesitas esperar una reforma que nunca llega. Existen países
                que hoy mismo quieren tu dinero, tu experiencia y tu ética de
                trabajo.
              </p>
            </div>
            <p data-id="element-156">
              Vivir sin documentos en EE.UU. es jugar a la ruleta rusa
              diariamente. Trabajas 12 horas, pagas impuestos, construyes una
              familia... pero un accidente, una revisión o un cambio político
              puede borrarlo todo en 24 horas.
            </p>
            <div className="border-l-2 border-[var(--accent)] pl-4 md:pl-5 py-1 my-1" data-id="element-157">
              <p className="font-serif italic text-[var(--text-heading)] text-base md:text-lg" data-id="element-158">
                "Lugares donde tus $5,000-$10,000 de ahorros se convierten en
                residencia permanente y la libertad de caminar sin mirar atrás."
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}